export interface UserAssetName {
    assetName: string;
    isValidName: boolean;
    errorMessage?: string;
}

export const getDefaultValueHof = (defaultAssetName: string) => (): UserAssetName => {
    return { assetName: defaultAssetName, isValidName: true };
};
